/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/libs/moment-config'
import "antd/dist/antd.css"
import "./src/styles/custom.antd.less"
import "react-day-picker/lib/style.css"
import "./src/styles/style.less"
import "./src/styles/modal.less"
import "react-alice-carousel/lib/alice-carousel.css"
import "./src/styles/privilege-detail.less"
import "./src/styles/custom.daypicker.less"
import "./src/styles/booking-form.less"
import "./src/styles/booking-details.less"
import "./src/styles/booking-coupon.less"
import "./src/styles/redeem-history.less"
import "./src/styles/booking-list.less"
import "./src/styles/news-activities.less"
import "./src/styles/loader.less"
import "./src/styles/responsive.less"
import "./src/styles/contact-info.less"
import "./src/libs/bs/css/bs.javascript.min.css"
import "./src/styles/bs.less"
import "./src/styles/status.less"
import "./src/styles/status-category-detail.less"
import "./src/styles/package.less"



const windowGlobal = typeof window !== 'undefined' && window



export const onRouteUpdate = ({ location, prevLocation }) => {

  
  windowGlobal.storageHistory = [
    ...(windowGlobal.storageHistory || []),
    {
      key: location.state && location.state.key,
      pathname: location.pathname,
      state: location.state,
      prev: {
        pathname: prevLocation && prevLocation.pathname,
        state: prevLocation && prevLocation.state
      }
    }
  ]

  if (location && location.state) {
    location.state.referrer = prevLocation ? prevLocation.pathname : null
  }
}

export const onClientEntry = () => {
  const metaNonce = document
    .querySelector("meta[name='csp-nonce']")
    ?.getAttribute("content");

  window.__NONCE__ = metaNonce || "";
};